//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TrustpilotReviews from "~/components/common-sections/trustpilot-reviews.vue";

export default {
  components: {
    TrustpilotReviews,
  },
  props: {
    data: {
      required: true,
    },
  },
};
